import Section from "../Section";
import Reviews from "../global/Reviews";

export default class FeaturedCollection extends Section {
    constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);

        this.review = new Reviews(pageLoad);
    }
}
